var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.page === "formContactUs"
      ? _c(
          "div",
          { attrs: { id: "app-form-contact-us" } },
          [
            _c("page-form-contact-us", {
              attrs: { "dealer-id": _vm.dealerId },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === "formRequestAppointment"
      ? _c(
          "div",
          { attrs: { id: "app-form-request-appointment" } },
          [
            _c("page-form-request-appointment", {
              attrs: { "dealer-id": _vm.dealerId },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === "localOfficeInfo"
      ? _c(
          "div",
          { attrs: { id: "app-local-office-info" } },
          [
            _c("page-local-office-info", {
              attrs: { "dealer-id": _vm.dealerId },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === "locationSearch"
      ? _c(
          "div",
          { attrs: { id: "app-location-search" } },
          [
            _c("page-location-search", {
              attrs: { "dealer-id": _vm.dealerId, "show-map": _vm.showMap },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === "nextAvailable"
      ? _c(
          "div",
          { attrs: { id: "app-next-available" } },
          [
            _c("page-next-available", {
              attrs: { "clinic-id": _vm.clinicId, "dealer-id": _vm.dealerId },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === "onlineScheduling"
      ? _c(
          "div",
          { attrs: { id: "app-online-scheduling" } },
          [
            _c("page-online-scheduling", {
              attrs: { "dealer-id": _vm.dealerId },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }